/**
 * 主入口
 */
document.addEventListener("DOMContentLoaded", function () {
  console.log("页面加载完成");

  // 图片预加载列表
  let spImgList = [
    // 在这里添加需要预加载的图片路径
  ];

  // 页面缩放适配
  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      if (document.body.clientWidth <= 1080) {
        let scale = document.body.clientWidth / 1080;
        $("#root").css("zoom", scale);
      } else {
        const scale = document.body.clientWidth / 1920;
        $("#root").css("zoom", scale);
      }

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              if (document.body.clientWidth <= 1080) {
                let scale = document.body.clientWidth / 1080;
                $("#root").css("zoom", scale);
              } else {
                const scale = document.body.clientWidth / 1920;
                $("#root").css("zoom", scale);
              }
            }, 100);
          };
        })()
      );
    });


    // IOS字体多了间距的处理
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent);

    if (!isAndroid && !isIOS && !isPC) {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();

    // 找到所有跳转套餐的锚点链接 - 使用事件委托确保所有链接都能工作
  function handleShoppingLinkClick(event) {
    const link = event.target.closest('a[href="#shopping"]');
    if (!link) return;
    
    event.preventDefault();
    
    const targetElement = document.getElementById("shopping");
    if (targetElement) {
      const offsetTop = targetElement.offsetTop;
      let sptop = document.body.clientWidth <= 1080 ? 50 : 0;
      let zoomValue = parseFloat($("div#root").css("zoom")) || 1;
      const scrollTop = offsetTop * zoomValue - sptop * zoomValue;

      window.scrollTo({
        top: scrollTop,
        behavior: "smooth",
      });
      
      setTimeout(() => {
        if (window.pageYOffset === 0 || Math.abs(window.pageYOffset - scrollTop) > 100) {
          $('html, body').animate({
            scrollTop: scrollTop
          }, 800);
        }
      }, 100);
    }
  }
  
  // 使用事件委托在document上监听所有点击
  document.addEventListener('click', handleShoppingLinkClick);

  // 滚动固定头部
  $(window).scroll(function () {
    if (
      $(window).scrollTop() >
      $(".sp_header").height() * $("div#root").css("zoom")
    ) {
      $(".sp_header-wrap").addClass("sp-fixed");
    } else {
      $(".sp_header-wrap").removeClass("sp-fixed");
    }
  });

  // 菜单交互
  $(".sp-menu-btn").click(function (e) {
    $(".sp-menu-mask").show();
  });

  $(".sp-menu-mask, .sp-close-btn").click(function (e) {
    $(".sp-menu-mask").hide();
  });

  jQuery(".sp-scroll").slide({
    mainCell: ".nav-imgs",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 12,
    vis: 1,
    scroll: 1,
  });

  new Swiper(".sp-swiper2", {
    slidesPerView: 5,
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
      reverseDirection: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  // 文本渐出动画（按模块分组，依次动画）
  const graduallyList2 = document.getElementsByClassName("sp-fade-box");
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll(".sp-ani");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`;
              span.style.animationDelay = `${index * 0.5 + 0.5}s`;
            });

            observerAni.unobserve(gradually2);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually2);
  }

  // 懒加载图片
  function lazyLoadImages() {
    const images = document.querySelectorAll(".lazy-load");
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          if (dataSrc) {
            image.src = dataSrc;
          }
          lazyLoadObserver.unobserve(image);
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image);
    });
  }

  lazyLoadImages();

  $(function () {
    // 判断是否为移动端
    function isMobile() {
      return document.body.clientWidth <= 1060;
    }

    // 购物车加购动效
    $(".cart-btn").click(function () {
      $(this).children("img").addClass("on");
      if (isMobile()) {
        $(".sp-mobile .sp-cart .num").show();
        $(".sp-mobile .sp-cart").addClass("on");
        setTimeout(function () {
          $(".sp-mobile .sp-cart").removeClass("on");
        }, 500);
      } else {
        $(".sp-pc .sp-header-top .sp-cart .num").show();
        $(".sp-pc .sp-header-top .sp-cart").addClass("on");
        setTimeout(function () {
          $(".sp-pc .sp-header-top .sp-cart").removeClass("on");
        }, 500);
      }
      setTimeout(function () {
        $(".cart-btn").children("img").removeClass("on");
      }, 500);
    });

    let initNum = 0;

    $(".product-part .cart-btn").click(function () {
      var data = {
        id: getCur().id,
        quantity: $('#calcNumber').val(),
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            // $("#cardNum").html(result.item_count);
            $(".cardNum").each(function () {
                $(this).html(result.item_count);
                $(this).removeClass("sp-gray");

            });
          });
        },
        dataType: "json",
      });

      var imgs = $(".sp-img-p.active");

      imgs.each(function () {
        var $img = $(this);
        var flyer = $img[0].cloneNode(true);
        flyer.classList.add("sp_clone");

        $(".product-part").append(flyer);

        // 获取图片在视口中的位置
        var imgRect = $img[0].getBoundingClientRect();
        $(flyer).css({
          width: $img[0].width,
          height: $img[0].height,
          background: "#e7e9ef",
          position: "fixed",
          top: imgRect.top,
          left: imgRect.left,
          "z-index": 99,
        });

        let finish, targetTop, targetLeft;

        if (isMobile()) {
          // 移动端：飞向底部固定按钮中的购物车
          finish = $(".sp-btn-style2.sp-mobile .sp-cart");
          if (finish.length > 0) {
            targetTop = $(".sp-btn-style2")[0].offsetTop;
            targetLeft =
              $(".sp-btn-style2 .sp-right")[0].offsetLeft + finish.width() + 20;
          } else {
            targetTop = 0;
            targetLeft = 0;
          }
          $(flyer).animate(
            {
              top: targetTop,
              left: targetLeft,
              width: 50,
              height: 50,
              opacity: 0.4,
            },
            500,
            "linear",
            function () {
              $(this).animate(
                {
                  width: 0,
                  height: 0,
                  opacity: 0,
                },
                0,
                function () {
                  $(this).detach();
                }
              );
            }
          );
        } else {
          // PC端：飞向header中的购物车
          finish = $(".header-inner.sp-pc .sp-cart");
          console.log("finish", finish);

          if (finish.length > 0) {
            var cartRect = finish[0].getBoundingClientRect();
            $(flyer).animate(
              {
                top: cartRect.top + cartRect.height / 2 - 30,
                left: cartRect.left + cartRect.width / 2,
                width: 50,
                height: 50,
                opacity: 0.4,
              },
              500,
              "linear",
              function () {
                $(this).animate(
                  {
                    width: 0,
                    height: 0,
                    opacity: 0,
                  },
                  0,
                  function () {
                    $(this).detach();
                  }
                );
              }
            );
          } else {
            console.error("PC端购物车元素未找到");
            $(flyer).detach();
          }
        }
      });
    });
  });

  // 型号选项点击事件（sp-qty）
  // $("#sp-qty .sp-option").click(function () {
  //   $(this).siblings().removeClass("active");
  //   $(this).addClass("active");
    
  //   // 获取选中的套餐索引
  //   const packageIndex = $(this).index();
    
  //   // 更新产品图片
  //   updateProductImage(packageIndex);
    
  //   // 获取当前数量并更新价格
  //   const quantity = parseInt($("#calcNumber").val()) || 1;
  //   // updatePrice(packageIndex, quantity);
    
  //   // 更新图片样式
  //   const $imgInnerImg = $(".product-part .sp-img-wrap .sp-img-inner-img");
  //   if (document.body.clientWidth <= 1060) {
  //     // 移动端
  //     if (packageIndex === 0) {
  //       // 选项1
  //       $imgInnerImg.css({
  //         "transform": "translateX(-50%) scale(1.4)",
  //         "width": "497px",
  //         "height": "274px"
  //       });
  //     } else if (packageIndex === 1) {
  //       // 选项2
  //       $imgInnerImg.css({
  //         "transform": "translateX(-50%) scale(1.6)",
  //         "width": "539px",
  //         "height": "240px"
  //       });
  //     }
  //   } else {
  //     // PC端
  //     if (packageIndex === 0) {
  //       // 选项1
  //       $imgInnerImg.css({
  //         "transform": "translateX(-50%) scale(0.9)",
  //         "width": "497px",
  //         "height": "274px"
  //       });
  //     } else if (packageIndex === 1) {
  //       // 选项2
  //       $imgInnerImg.css({
  //         "transform": "translateX(-50%) scale(1)",
  //         "width": "539px",
  //         "height": "240px"
  //       });
  //     }
  //   }
  //   changePrice()
  // });
});

// ==================== TopBar 模块 JS（AI 生成） ====================
// 顶部公告栏轮播
new Swiper(".sp-swiper-fade", {
  spaceBetween: 10,
  effect: "fade",
  autoplay: {
    disableOnInteraction: false,
    delay: 2000,
  },
  speed: 2000,
});

// ==================== sp-part11 走马灯 ====================
// 移动端 Award Winning Designs 走马灯（使用 CSS 动画，无需 JS）

// ==================== sp-part9 轮播图 ====================
// 移动端图片轮播
new Swiper(".sp-part9-swiper", {
  autoplay: {
    delay: 3500,
    disableOnInteraction: false,
  },
  slidesPerView: 1,
  spaceBetween: 0,
  loop: true,
  pagination: {
    el: ".sp-part9-pagination",
    clickable: true,
  },
});

// ==================== sp-part4 PC端轮播图 ====================
// PC端 Before & After 对比轮播
new Swiper(".sp-part4-swiper", {
  autoplay: {
    delay: 3500,
    disableOnInteraction: false,
  },
  slidesPerView: 1,
  spaceBetween: 0,
  loop: true,
  pagination: {
    el: ".sp-part4-pagination",
    clickable: true,
  },
});

// ==================== sp-part6 移动端轮播图 ====================
// 移动端 Before & After 对比轮播
new Swiper(".sp-part6-swiper", {
  autoplay: {
    delay: 3500,
    disableOnInteraction: false,
  },
  slidesPerView: 1,
  spaceBetween: 0,
  loop: true,
  pagination: {
    el: ".sp-part6-pagination",
    clickable: true,
  },
});


 new Swiper('.sp-swiper4', {
    slideShadows: true,
    slidesPerView: 'auto',
    spaceBetween: 40,
    centeredSlides: true,
    loop: true, //循环滚动
    freeMode: true,
    speed: 26500, //匀速时间
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
  })

// ==================== sp-part7 PC端交叠轮播图 ====================
// PC端图片轮播（带交叠效果）
new Swiper(".sp-part7-swiper", {
  autoplay: {
    delay: 3500,
    disableOnInteraction: false,
  },
  slidesPerView: "auto",
  spaceBetween: 0,
  centeredSlides: true,
  loop: true,
  pagination: {
    el: ".sp-part7-pagination",
    clickable: true,
  },
  effect: "slide",
  speed: 800,
  on: {
    slideChange: function () {
      // 确保当前激活的slide有高亮效果
      const activeSlide = this.slides[this.activeIndex];
      this.slides.forEach((slide) => {
        slide.classList.remove("swiper-slide-active");
        slide.classList.remove("swiper-slide-prev");
        slide.classList.remove("swiper-slide-next");
      });
      activeSlide.classList.add("swiper-slide-active");

      // 设置prev和next的z-index
      const prevIndex =
        (this.activeIndex - 1 + this.slides.length) % this.slides.length;
      const nextIndex = (this.activeIndex + 1) % this.slides.length;

      const prevSlide = this.slides[prevIndex];
      const nextSlide = this.slides[nextIndex];

      prevSlide.classList.add("swiper-slide-prev");
      nextSlide.classList.add("swiper-slide-next");
    },
    slideChangeTransitionStart: function () {
      // 确保当前激活的slide有高亮效果
      const activeSlide = this.slides[this.activeIndex];
      this.slides.forEach((slide) => {
        slide.classList.remove("swiper-slide-active");
        slide.classList.remove("swiper-slide-prev");
        slide.classList.remove("swiper-slide-next");
      });
      activeSlide.classList.add("swiper-slide-active");

      // 设置prev和next的z-index
      const prevIndex =
        (this.activeIndex - 1 + this.slides.length) % this.slides.length;
      const nextIndex = (this.activeIndex + 1) % this.slides.length;

      const prevSlide = this.slides[prevIndex];
      const nextSlide = this.slides[nextIndex];

      prevSlide.classList.add("swiper-slide-prev");
      nextSlide.classList.add("swiper-slide-next");
    },
  },
});

$(".q-row").click(function () {
  $(this).parent().toggleClass("sp-show");
});

// ========== 购物模块逻辑 ==========

//购物模块相关
/**倒计时 */

// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();


const imgList = [
  'https://cdn.shopify.com/s/files/1/0932/0654/4667/files/20260316__img__5.png?v=1773659770',
  'https://cdn.shopify.com/s/files/1/0932/0654/4667/files/20260316__img__4.png?v=1773659770',
  'https://cdn.shopify.com/s/files/1/0932/0654/4667/files/20260316__img__2.png?v=1773659770',
  'https://cdn.shopify.com/s/files/1/0932/0654/4667/files/20260316__img__3.png?v=1773659770',
  'https://cdn.shopify.com/s/files/1/0932/0654/4667/files/20260316__img__6.png?v=1773659770',
  'https://cdn.shopify.com/s/files/1/0932/0654/4667/files/20260316__img__1.png?v=1773659770',

  'https://cdn.shopify.com/s/files/1/0567/3520/3402/files/20260129-car-1.png',

  'https://cdn.shopify.com/s/files/1/0932/0654/4667/files/20260309__img_11.png?v=1773047741',
  'https://cdn.shopify.com/s/files/1/0932/0654/4667/files/20260309__img_22.png?v=1773047741',
  'https://cdn.shopify.com/s/files/1/0932/0654/4667/files/20260309__img_33.png?v=1773047741',
  'https://cdn.shopify.com/s/files/1/0932/0654/4667/files/20260309__img_55.png?v=1773047741',
  'https://cdn.shopify.com/s/files/1/0932/0654/4667/files/20260309__img_66.png?v=1773047741',
  'https://cdn.shopify.com/s/files/1/0932/0654/4667/files/20260309__img_44.png?v=1773047741',
  'https://cdn.shopify.com/s/files/1/0932/0654/4667/files/20260309__img_77.png?v=1773047741',

  // 'https://cdn.shopify.com/s/files/1/0932/0654/4667/files/20260309__img_1.png?v=1773044231',
  // 'https://cdn.shopify.com/s/files/1/0932/0654/4667/files/20260309__img_2.png?v=1773044231',
  // 'https://cdn.shopify.com/s/files/1/0932/0654/4667/files/20260309__img_3.png?v=1773044231',
  // 'https://cdn.shopify.com/s/files/1/0932/0654/4667/files/20260309__img_4.png?v=1773044231',
  // 'https://cdn.shopify.com/s/files/1/0932/0654/4667/files/20260309__img_5.png?v=1773044231',
  // 'https://cdn.shopify.com/s/files/1/0932/0654/4667/files/20260309__img_6.png?v=1773044231',
  // 'https://cdn.shopify.com/s/files/1/0932/0654/4667/files/20260309__img_7.png?v=1773044231',
  // 'https://cdn.shopify.com/s/files/1/0932/0654/4667/files/lQLPD3Kaj-jPJVXMzs0CUrD_D58T9wQK6gl82t753sAA_594_206.png?v=1772433532',
  // 'https://cdn.shopify.com/s/files/1/0932/0654/4667/files/lQLPM4T1kgVYFVnNAnvNA1qwkunHCkMarVQJhcy0fUs8AA_858_635.png?v=1773029819',
  // 'https://cdn.shopify.com/s/files/1/0932/0654/4667/files/lQLPM5xmapuSdVnNAnvNA1qwGZ9RFQtU-8wJhcyzy19MAA_858_635.png?v=1773029818',
  // 'https://cdn.shopify.com/s/files/1/0932/0654/4667/files/lQLPD3J1RcDsBVnNAnvNA1qw-ht-9KE1brsJhcy0CsZ6AA_858_635.png?v=1773029816',
  // 'https://cdn.shopify.com/s/files/1/0932/0654/4667/files/lQLPM50eIl_bNFnNAybNBAWwcFWr85yiMgEJhcyzXHnfAA_1029_806.png?v=1773029820',
]
function preloadImages(imageArray) {
  // 预加载
  // 检查数组数据结构
  if (Array.isArray(imageArray[0])) {
    // 处理二维数组
    imageArray.forEach((subArray) => {
      subArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    });
  } else {
    // 处理一维数组
    imageArray.forEach((url) => {
      const img = new Image();
      img.src = url;
    });
  }
}

preloadImages(imgList);

// 样式选项点击事件（sp-type）
$("#sp-type .sp-option").click(function () {
  $(this).siblings().removeClass("active");
  $(this).addClass("active");
  // updateStyleImage();
});

// 样式选项点击事件（sp-adds）
$("#sp-qty .sp-option").click(function () {
  $(this).siblings().removeClass("active");
  $(this).addClass("active");
  // updateStyleImage();
  const defaultIndex = $("#sp-qty .sp-option.active").index();
  changePrice()

  $(".sp-img-p").attr("src", imgList[defaultIndex]);
});

// 套餐配置
const packageConfig = {
  0: {
    // Buy 1 PC (套餐1)
    image: "https://cdn.shopify.com/s/files/1/0567/3520/3402/files/20260129-car-1.png",
    price: 65.99,
    originalPrice: 99.99,
  },
  1: {
    // Buy 2 PCS Save £5.99 (套餐2)
    image: "https://cdn.shopify.com/s/files/1/0567/3520/3402/files/20260129-car-2.png",
    price: 65.99,
    originalPrice: 99.99,
  },
  2: {
    // Buy 3 Get 1 Free (4 PCS) (套餐2)
    image: "https://cdn.shopify.com/s/files/1/0567/3520/3402/files/20260129-car-2.png",
    price: 65.99,
    originalPrice: 99.99,
  },
};

// 更新产品图片
function updateProductImage(packageIndex) {
  const config = packageConfig[packageIndex];
  if (config) {
    $(".sp-img-p").attr("src", config.image);
  }
}

// 更新价格显示
function updatePrice(packageIndex, quantity) {
  const config = packageConfig[packageIndex];
  if (!config) return;

  let totalPrice = config.price * quantity;
  let totalOriginalPrice = config.originalPrice * quantity;

  // 根据套餐应用折扣
  if (packageIndex === 1) {
    // Buy 2 PCS Save £5.99
    if (quantity >= 2) {
      totalPrice = config.price * quantity - 5.99;
    }
  } else if (packageIndex === 2) {
    // Buy 3 Get 1 Free (4 PCS)
    if (quantity >= 3) {
      const freeCount = Math.floor(quantity / 3);
      totalPrice = config.price * (quantity - freeCount);
      totalOriginalPrice = config.originalPrice * quantity;
    }
  }

  // 更新价格显示
  $("#sp_price1").html("$" + totalPrice.toFixed(2));
  $("#sp_price2").html("$" + totalOriginalPrice.toFixed(2));
}



// 数量变化时更新价格
function updatePriceOnQuantityChange() {
  const activePackageIndex = $("#sp-qty .sp-option.active").index();
  const quantity = parseInt($("#calcNumber").val()) || 1;
  updatePrice(activePackageIndex, quantity);
}

let prods = window.product
  
function getCur(){
    let opt1 = $('#sp-qty div.active').attr('data-val')
    let opt2 = $('#sp-adds div.active').attr('data-val')
    return prods.filter(item=> item.option1 == opt1)[0]
}
function changePrice(){
    let num = $('#calcNumber').val()
    let price = (getCur().price * num / 100).toFixed(2)
    let compare = (getCur().compare_at_price * num / 100).toFixed(2)
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    console.log(price)
    $('#sp_price1 span').html(price)
    $('#sp_price2 span').html(compare)
    let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
    $(".product-part .price-group .off-font").html(off_font);

}
$('.sp-btn-style').click(function(){
    let num = $('#calcNumber').val()
    window.location.href = '/cart/' + getCur().id + ':' + num
})

// 数量调整按钮点击事件
$(document).on("click", ".sp-reduce", function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) - 1;
  if (num > 0) {
    input.value = num;
    changePrice()
  }
});

$(document).on("click", ".sp-add", function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) + 1;
  input.value = num;
  changePrice()
});

// 输入框变化时也更新价格
$(document).on("input change", "#calcNumber", function () {
  const value = parseInt($(this).val()) || 1;
  if (value > 0) {
    $(this).val(value);
    changePrice()
  }
});

// 初始化：设置默认图片和价格
  $(document).ready(function () {
    const defaultPackageIndex = $("#sp-qty .sp-option.active").index();
    const defaultQuantity = parseInt($("#calcNumber").val()) || 1;
    // updateProductImage(defaultPackageIndex);
    // updatePrice(defaultPackageIndex, defaultQuantity);
    
    // 初始化图片样式
    // const $imgInnerImg = $(".product-part .sp-img-wrap .sp-img-inner-img");
    // if (document.body.clientWidth <= 1060) {
    //   // 移动端
    //   if (defaultPackageIndex === 0) {
    //     // 选项1
    //     $imgInnerImg.css({
    //       "transform": "translateX(-50%) scale(1.4)",
    //       "width": "497px",
    //       "height": "274px"
    //     });
    //   } else if (defaultPackageIndex === 1) {
    //     // 选项2
    //     $imgInnerImg.css({
    //       "transform": "translateX(-50%) scale(1.6)",
    //       "width": "539px",
    //       "height": "240px"
    //     });
    //   }
    // } else {
    //   // PC端
    //   if (defaultPackageIndex === 0) {
    //     // 选项1
    //     $imgInnerImg.css({
    //       "transform": "translateX(-50%) scale(0.9)",
    //       "width": "497px",
    //       "height": "274px"
    //     });
    //   } else if (defaultPackageIndex === 1) {
    //     // 选项2
    //     $imgInnerImg.css({
    //       "transform": "translateX(-50%) scale(1)",
    //       "width": "539px",
    //       "height": "240px"
    //     });
    //   }
    // }
  });

// ========== 菜单模块逻辑 ==========
// 移动端菜单开关
$(".sp-menu-btn").click(function () {
  $(".sp-menu-mask").fadeIn();
});

$(".sp-close-btn, .sp-menu-mask").click(function (e) {
  if (e.target === this) {
    $(".sp-menu-mask").fadeOut();
  }
});

// 菜单项点击后关闭菜单
$(".sp-menu-item a").click(function () {
  $(".sp-menu-mask").fadeOut();
});

// ========== 购物车飞入动画效果 ==========
// let initNum = 0;
// $(document).on("click", ".addCart", function() {
//   // 购物车加购动效
//   $(this).children("img").addClass("on");
//   $(".sp-cart .cardNum").show();
//   setTimeout(function() {
//     $(".addCart").children("img").removeClass("on");
//   }, 500);
//   $(".sp-cart").addClass("on");
//   setTimeout(function() {
//     $(".sp-cart").removeClass("on");
//   }, 500);

//   let spNum = $("#calcNumber")[0].value;
//   initNum += Number(spNum);

//   $(".cardNum").each(function() {
//     $(this).html(initNum);
//   });
//   $(".cardNum").removeClass("sp-gray");

//   var imgs = $(".sp-img-p.active");

//   imgs.each(function() {
//     var $img = $(this);
//     var flyer = $img[0].cloneNode(true);
//     flyer.classList.add("sp_clone");

//     $(".sp_product_content").append(flyer);

//     var imgRect = $img[0].getBoundingClientRect();
//     var zoom = parseFloat($("div#root").css("zoom")) || 1;

//     $(flyer).css({
//       width: $img[0].width,
//       height: $img[0].height,
//       background: "#e7e9ef",
//       position: "fixed",
//       top: imgRect.top,
//       left: imgRect.left,
//       "z-index": 99,
//     });
//     let finish;
//     if (document.body.clientWidth <= 1080) {
//       finish = $(".sp-btn-style2.sp-mobile .sp-cart");
//       var cartRect = finish[0].getBoundingClientRect();
//       var zoom = parseFloat($("div#root").css("zoom")) || 1;

//       $(flyer).animate(
//         {
//           top: cartRect.top + cartRect.height / 2,
//           left: cartRect.left + cartRect.width / 2,
//           width: 50,
//           height: 50,
//           opacity: 0.4,
//         },
//         500,
//         "linear",
//         function() {
//           $(this).animate(
//             {
//               width: 0,
//               height: 0,
//               opacity: 0,
//             },
//             0,
//             function() {
//               $(this).detach();
//             }
//           );
//         }
//       );
//     } else {
//       finish = $(".header-inner.sp-pc .sp-cart");
//       var cartRect = finish[0].getBoundingClientRect();
//       var zoom = parseFloat($("div#root").css("zoom")) || 1;

//       $(flyer).animate(
//         {
//           top: cartRect.top + cartRect.height / 2,
//           left: cartRect.left + cartRect.width / 2,
//           width: 50,
//           height: 50,
//           opacity: 0.4,
//         },
//         500,
//         "linear",
//         function() {
//           $(this).animate(
//             {
//               width: 0,
//               height: 0,
//               opacity: 0,
//             },
//             0,
//             function() {
//               $(this).detach();
//             }
//           );
//         }
//       );
//     }
//   });
// });
